import script from "./OwnerCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./OwnerCreate.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__